module.exports = __webpack_public_path__ + "media/10_2.69c78e48.wav";